import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";

/* eslint no-console: ["off"] */
import styleConsole from './styleConsole';

function format(category, arg0) {
  var _context, _context2;

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return _concatInstanceProperty(_context = [_concatInstanceProperty(_context2 = "%c".concat(category, "%c ")).call(_context2, arg0)]).call(_context, _toConsumableArray(styleConsole('green', 'white')), args);
}

export default function debug(category) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$force = _ref.force,
      force = _ref$force === void 0 ? false : _ref$force;

  if (!force) {
    return function () {
      return 0;
    };
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (!args.length) {
      return;
    }

    var _args = args,
        _args2 = _slicedToArray(_args, 1),
        arg0 = _args2[0];

    if (typeof arg0 === 'function') {
      args = arg0();
    }

    var lines = _Array$isArray(args[0]) ? args : [args];
    var oneLiner = lines.length === 1;

    _forEachInstanceProperty(lines).call(lines, function (line, index) {
      if (oneLiner) {
        var _console, _context3;

        (_console = console).log.apply(_console, _toConsumableArray(format.apply(void 0, _concatInstanceProperty(_context3 = [category]).call(_context3, _toConsumableArray(line)))));
      } else if (index) {
        var _console2;

        (_console2 = console).log.apply(_console2, _toConsumableArray(_Array$isArray(line) ? line : [line]));
      } else {
        var _console3, _context4;

        (_console3 = console).groupCollapsed.apply(_console3, _toConsumableArray(format.apply(void 0, _concatInstanceProperty(_context4 = [category]).call(_context4, _toConsumableArray(line)))));
      }
    });

    oneLiner || console.groupEnd();
  };
}
